import React from 'react';
import Icon from '../Icon';

const Step = ({ n, title, body, meta }) => (
  <div className="step reveal">
    <div className="step-num">{n}</div>
    <h3>{title}</h3>
    <p>{body}</p>
    <div className="step-meta"><Icon name="clock" size={13} stroke={2.4} /> {meta}</div>
  </div>
);

const HowItWorks = ({ onCTA }) => (
  <section className="section-how">
    <div className="container">
      <div className="section-head center">
        <span className="eyebrow">How it works</span>
        <h2 className="section-title">From "I had no idea" to <em>first payment</em>, in three steps.</h2>
      </div>

      <div className="steps-grid">
        <Step n="01" title="Check eligibility" body="Answer 14 short questions about who you care for and what kind of help they need. No documents required at this stage." meta="2 minutes" />
        <Step n="02" title="We review & reach out" body="A care advocate reviews your answers, identifies which programs apply in your state, and calls you with a personalized plan." meta="Within 24 hours" />
        <Step n="03" title="Get help applying" body="We prepare every form, coordinate with your loved one's doctor, and stay on the phone with the agency until you're approved." meta="Avg. 14 days to approval" />
      </div>

      <div className="steps-cta">
        <button className="btn btn-primary btn-lg" onClick={onCTA}>
          Start with step 1 — it's free
          <Icon name="arrow-right" size={18} stroke={2.4} className="arrow" />
        </button>
      </div>
    </div>
  </section>
);

export default HowItWorks;
